/**
 * Stosuje wybrany kolor akcentu do całej aplikacji przez podmianę
 * CSS var-ów na :root. Wszystkie komponenty używają `bg-green`,
 * `text-forest`, `bg-accent`, itd. — które są mapowane przez Tailwind
 * v4 (@theme inline) na var(--kd-green/forest/accent), więc wystarczy
 * nadpisać te zmienne.
 *
 * `forest` = ciemniejszy wariant (88% mix z czarnym) — używany przez
 * shadow-cta + money positive. `accent-soft` = wariant 14% nad transparent
 * dla subtelnych tła.
 */
export function applyAccent(color: string): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement.style;
  root.setProperty("--kd-green", color);
  root.setProperty("--kd-forest", `color-mix(in srgb, ${color} 88%, black)`);
  root.setProperty("--kd-money", `color-mix(in srgb, ${color} 88%, black)`);
  root.setProperty("--kd-accent", color);
  root.setProperty(
    "--kd-accent-soft",
    `color-mix(in srgb, ${color} 14%, transparent)`,
  );
}
